const copyBtns = document.querySelectorAll('.copy-btn');

copyBtns.forEach(btn => {
  btn.addEventListener('click', event => {
    const copyBox = event.target.closest('.copy-box');
    if (!copyBox) return;

    const copyElem = copyBox.querySelector('.copy-elem');
    if (!copyElem) return;

    const textToCopied = copyBox.dataset.copied;
    const clipboardElem = copyBox.dataset.clipboard;

    if (!navigator.clipboard || !clipboardElem) return;

    if (!copyBox.originalText) {
      copyBox.originalText = copyElem.textContent;
    }

    navigator.clipboard
      .writeText(clipboardElem)
      .then(() => {
        const width = copyElem.offsetWidth;
        copyElem.style.minWidth = `${width}px`;

        copyBox.classList.add('is-copy');

        if (textToCopied) copyElem.textContent = textToCopied;

        if (copyBox.timer) clearTimeout(copyBox.timer);

        copyBox.timer = setTimeout(() => {
          copyElem.textContent = copyBox.originalText;
          copyBox.classList.remove('is-copy');

          requestAnimationFrame(() => {
            copyElem.style.minWidth = '';
          });

          copyBox.timer = null;
        }, 1000);
      })
      .catch(err => {
        console.error('Помилка при копіюванні: ', err);
      });
  });
});

// <div
//   class="copy-box"
//   data-copied="Copied to the clipboard"
//   data-clipboard="Clipboard"
// >
//   <button type="button" class="copy-btn" aria-label="Copy button">
//     X
//   </button>
//   <a href="#" class="copy-elem">
//     Clipboard
//   </a>
// </div>
